import React from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, {formatDate, parseDate} from 'react-day-picker/moment';
import moment from 'moment';

import {USER_LANG} from 'utils/locale';
import {gettext} from 'utils/text';


const dayPickerOptions = {
    formatDate,
    parseDate,
    placeholder: gettext("Select..."),
    dayPickerProps: {
        locale: USER_LANG,
        localeUtils: MomentLocaleUtils,
    },
    inputProps: {
        className: 'form-control',
    },
};

const DateRangePicker = ({setStartDay, setEndDay}) => (
    <div className="d-flex">
        <div className="mr-3">
            <div className="mb-2">{gettext("Start date")}</div>
            <DayPickerInput
                onDayChange={day => setStartDay(moment.isDate(day) ? moment(day).startOf('day') : null)}
                {...dayPickerOptions}
            />
        </div>
        <div className="">
            <div className="mb-2">{gettext("End date")}</div>
            <DayPickerInput
                onDayChange={day => setEndDay(moment.isDate(day) ? moment(day).endOf('day') : null)}
                {...dayPickerOptions}
            />
        </div>
    </div>
);

DateRangePicker.propTypes = {
    setStartDay: PropTypes.func.isRequired,
    setEndDay: PropTypes.func.isRequired,
};


export default DateRangePicker;



// WEBPACK FOOTER //
// ./src/components/DateRangePicker.js